declare var bzip2: any;

export class Base64TextConverter {
  public toCompressedBase64(data: string): string {
    let dataStrUTF8: string = unescape(encodeURIComponent(data));
    let dataRawUTF8: number[] = new Array<number>(dataStrUTF8.length);
    for (let i = 0; i < dataStrUTF8.length; ++i) {
      dataRawUTF8[i] = dataStrUTF8.charCodeAt(i);
    }
    let dataRawZIP: any = bzip2.compressFile(dataRawUTF8);
    return btoa(String.fromCharCode.apply(null, dataRawZIP));
  }
}
